import { Badge } from '@/components/ui/badge'
import { getApplicationEnrichedStatus } from '@almaris/shared/helpers/getApplicationInfo'
import { WebappApplicationFragment } from '@gql'
import React from 'react'
import { useTranslation } from 'react-i18next'

type ApplicationStatusBadgeProps = {
  application: WebappApplicationFragment
}

export const ApplicationStatusBadge = ({
  application,
}: ApplicationStatusBadgeProps) => {
  const { t } = useTranslation()

  const applicationEnrichedStatus = getApplicationEnrichedStatus(application)

  const statusText = t(`common.applicationStatus.${applicationEnrichedStatus}`)

  const variant =
    applicationEnrichedStatus === 'PreAccepted' ||
    applicationEnrichedStatus === 'UnderPromise' ||
    applicationEnrichedStatus === 'ActSigned' ||
    applicationEnrichedStatus === 'Submitted'
      ? 'success'
      : applicationEnrichedStatus === 'Cancelled'
        ? 'destructive'
        : 'secondary'

  return (
    <Badge variant={variant} className="tw-ml-2">
      {statusText}
    </Badge>
  )
}
